import { Component } from '@angular/core';
import { CompanyStatusPipe } from "@shared/pipes/companyStatusPipe";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from 'ag-grid-community';
import { CompanyStatus } from '@models/companies/company-enums';

@Component({
  selector: 'app-ag-company-status',
  standalone: true,
  imports: [
    CompanyStatusPipe
  ],
  templateUrl: './ag-company-status.component.html',
  styleUrl: './ag-company-status.component.scss'
})
export class AgCompanyStatusComponent implements ICellRendererAngularComp {
  status = 0;
  CompanyStatus = CompanyStatus;

  agInit(params: ICellRendererParams): void {
    this.status = params.value as number;
  }

  refresh(params: ICellRendererParams): boolean {
    this.status = params.value as number;
    return true;
  }
}
